/* eslint-disable zeffy-linter-frontend/no-classname-prop -- legacy baseline (pre-rule); remove when these are migrated */
import React from "react";

interface PDFContentViewerProps {
  html?: string;
  breakpoint: string;
  isSkeleton?: boolean;
  aspectRatio?: number;
  width?: number;
  height?: number;
  rounded?: boolean;
  scaleSettings?: {
    xl: number;
    lg: number;
    md: number;
    xs: number;
  };
}

export const PDFContentViewer: React.FC<PDFContentViewerProps> = ({
  html,
  breakpoint,
  isSkeleton = false,
  width = 1275,
  height = 1647,
  aspectRatio = width / height,
  rounded = false,
  scaleSettings,
}) => {
  const initialScale = scaleSettings?.[breakpoint as keyof typeof scaleSettings] || 0.33;

  // Sanitize HTML to remove any inline style property with a physical unit
  const sanitizeHtml = (inputHtml?: string) => {
    if (!inputHtml) {
      return "";
    }
    // Remove any inline style property with a value in mm - millimeters (only within style attributes)
    return inputHtml.replace(/style="([^"]*)"/gi, (_match: string, styleContent: string) => {
      const cleanedStyle = styleContent.replace(/\s*[\w-]+\s*:\s*[^;]*mm\s*;?/gi, "");
      return cleanedStyle ? `style="${cleanedStyle}"` : "";
    });
  };

  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <style>
          {`
            html, body { 
              margin: 0;
              padding: 0;
              height: 100%;
              overflow: hidden;
            }
            body {
              background-color: #F8F8FA;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .preview-container {
              transform-origin: center;
              transform: scale(var(--scale-factor, ${initialScale}));
              background-color: ${rounded ? "transparent" : "white"};
              aspect-ratio: ${aspectRatio};
              width: ${width}px;
              height: ${height}px;
              flex-shrink: 0;
            }
            ${
              rounded
                ? `
              .preview-container html,
              .preview-container body {
                background: transparent !important;
              }
              .ticket {
                border-radius: 48px;
                overflow: hidden;
              }
            `
                : ""
            }
            .main:not(:first-of-type),
            .ticket:not(:first-of-type) {
              display: none;
            }
            ${
              isSkeleton
                ? `
              @keyframes loading {
                0% { background-position: 200% 0; }
                100% { background-position: -200% 0; }
              }
              .skeleton {
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                background-size: 200% 100%;
                animation: loading 7s infinite;
              }
            `
                : ""
            }
          `}
        </style>
      </head>
      <body>
        <div className="preview-container" data-aspect-ratio={aspectRatio} data-scale-tweak={isSkeleton ? 0.98 : 1}>
          {isSkeleton ? <div className="skeleton" /> : <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />}
        </div>
      </body>
    </html>
  );
};
